// One threshold for visual loading indicators. Accessibility state and duplicate protection
// are immediate; only the visual affordance waits, avoiding a flash on sub-150ms requests.
export const BUSY_INDICATOR_DELAY = 150

export class BusyDelay {
  constructor({ show, hide, delay = BUSY_INDICATOR_DELAY, timers = globalThis }) {
    this.show = show
    this.hide = hide
    this.delay = delay
    this.timers = timers
    this.timer = null
    this.generation = 0
  }

  start() {
    this.finish()
    const generation = this.generation
    this.timer = this.timers.setTimeout(() => {
      if (generation !== this.generation) return
      this.timer = null
      this.show()
    }, this.delay)
  }

  finish() {
    this.generation += 1
    if (this.timer !== null) this.timers.clearTimeout(this.timer)
    this.timer = null
    this.hide()
  }
}
